<template>
    <el-form ref="uploadform" :model="form" :rules="rules" label-width="80px" class="uploadForm" size="small" v-loading="loading">
        <el-row :gutter="10">
            <el-col :span="8">
                <el-form-item label="水样类型">
                    <el-select v-model="form.WaterType" placeholder="请选择水样类型" @change="handlerWaterTypeChange">
                        <el-option label="普通观测" value="Observation"></el-option>
                        <el-option label="超纯水" value="Type2Water"></el-option>
                        <el-option label="标准溶液" value="StandardSample"></el-option>
                        <el-option label="企业样本" value="Sample"></el-option>
                        <el-option label="背景水" value="BGWater"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="8">
                <el-form-item label="设备编号" prop="EquipmentId">
                    <!--<el-input v-model="form.EquipmentId"></el-input>-->
                    <el-select v-model="form.EquipmentId" placeholder="请选择设备" size="mini" @change="handlerEquipmentChange">
                        <el-option v-for="item in eqoptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8" v-show="waterTypeShow.BGWaterId">
                <el-form-item label="背景水">
                    <!--<el-input v-model="form.BGWaterId"></el-input>-->
                    <el-select v-model="form.BGWaterId" placeholder="请选择背景水" size="mini" filterable>
                        <el-option v-for="item in bgwateroptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8" v-show="waterTypeShow.Type2WaterId">
                <el-form-item label="超纯水">
                    <!--<el-input v-model="form.Type2WaterId"></el-input>-->
                    <el-select v-model="form.Type2WaterId" placeholder="请选择超纯水" size="mini" filterable>
                        <el-option v-for="item in type2wateroptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="8" v-show="waterTypeShow.CompanyId">
                <el-form-item label="所属公司">
                    <el-select v-model="form.CompanyId" placeholder="请选择所属公司" size="mini">
                        <el-option v-for="item in companyoptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8" v-show="waterTypeShow.CompanyId">
                <el-form-item label="样本库">
                    <el-select v-model="form.SampleLibraryId" placeholder="请选择所属样本库" size="mini">
                        <el-option v-for="item in sampleLibraries"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8" v-show="waterTypeShow.CompanyId">
                <el-form-item label="样本类型">
                    <el-select v-model="form.TypeId" placeholder="请选择样本类型" size="mini">
                        <el-option v-for="item in sampleTypes"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-form-item label="选择文件">
            <upload-select ref="uploadSelector" key="us" @uploadChanged="handleruploadChanged(arguments)"/>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit('uploadform')" size="medium">立即上传</el-button>
            <el-button size="medium">取消</el-button>
        </el-form-item>
    </el-form>
</template>
    <script>
        import { Uploader, getListPage, getListPageByEquipmentId } from '@/api/utils';
        import UploadSelect from "@/components/UploadSelect.vue";

        export default {
            name: 'uploadWater',
            components: {
                UploadSelect
            },
            data() {
                return {
                    timer:'',
                    form: {
                        WaterType: 'Observation',
                        EquipmentId: '',
                        BGWaterId: '',
                        Type2WaterId: '',
                        CompanyId:'',
                        TypeId: '',
                        SampleLibraryId: '',
                    },
                    eqoptions: [],
                    bgwateroptions: [],
                    type2wateroptions: [],
                    companyoptions:[],
                    sampleLibraries: [],
                    sampleTypes: [],
                    rules: {
                        EquipmentId: [
                            { required: true, message: '请选择设备', trigger: 'blur' }
                        ],
                        CompanyId: [
                            { required: true, message: '请选择所属公司', trigger: 'blur' }
                        ]
                    },
                    waterTypeShow: {
                        BGWaterId: true,
                        Type2WaterId: true,
                        CompanyId:false
                    },
                    uploadDataList: [{
                        filename: '',
                        CreateTime: '',
                        Remark: ''
                    }],
                    loading: false
                }
            },
            async created() {
                await this.getequipmentoptions();
                await this.getbgwateroptions();
                await this.gettype2wateroptions();
                await this.getSampleLibraries();
                await this.getSampleTypes();
            },
            methods: {
                async getequipmentoptions() {
                    let res = await getListPage("Equipment", {});
                    if (res.Data) {
                        //this.eqlist = res.Data.list;
                        res.Data.list.forEach(item => {
                            this.eqoptions.push({ value: item.Id, label: item.Code });
                        });
                    }
                },
                async getbgwateroptions() {
                    let res = await getListPage("BGWater", {});
                    if (res.Data) {
                        res.Data.list.forEach(item => {
                            this.bgwateroptions.push({ value: item.Id, label: item.Id + " | " + item.CreateTime });
                        });
                    }
                },
                async gettype2wateroptions() {
                    let res = await getListPage("Type2Water", {});
                    if (res.Data) {
                        res.Data.list.forEach(item => {
                            this.type2wateroptions.push({ value: item.Id, label: item.Id + " | " + item.CreateTime });
                        });
                    }
                },
                async getcompanyoptions(eqId) {
                    let res = await getListPageByEquipmentId("RegulatedCompany", { equipmentId:eqId});
                    if (res.Data) {
                        this.companyoptions = [];
                        res.Data.list.forEach(item => {
                            this.companyoptions.push({ value: item.Id, label: item.Name });
                        });
                    }
                },
                async getSampleLibraries() {
                    let res = await getListPage("SampleLibrary");
                    if (res.Data) {
                        this.sampleLibraries = [];
                        res.Data.list.forEach(item => {
                            this.sampleLibraries.push({ value: item.Id, label: item.Name });
                        });
                    }
                },
                async getSampleTypes() {
                    let res = await getListPage("SampleType");
                    if (res.Data) {
                        this.sampleTypes = [];
                        res.Data.list.forEach(item => {
                            this.sampleTypes.push({ value: item.Id, label: item.Name });
                        });
                    }
                },
                handlerWaterTypeChange(args) {
                    switch (args) {
                        case 'Observation':
                            this.waterTypeShow.BGWaterId = true;
                            this.waterTypeShow.Type2WaterId = true;
                            this.waterTypeShow.CompanyId = false;
                            break;
                        case 'Type2Water':
                        case 'StandardSample':
                        case 'Sample':
                        case 'BGWater':
                            this.waterTypeShow.BGWaterId = false;
                            this.waterTypeShow.Type2WaterId = false;
                            this.waterTypeShow.CompanyId = args === 'Sample';
                            break;
                        default:
                    }
                },
                async handlerEquipmentChange(args) {
                    await this.getcompanyoptions(args);
                    // console.log(this.companyoptions);
                },
                handleruploadChanged(args) {
                    this.uploadDataList = args[0];
                },
                onSubmit(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            let that = this;
                            this.loading = true;
                            let infos = JSON.parse(JSON.stringify(this.form));
                            infos.CreateTime = this.uploadDataList.map(v => v.createTime);
                            infos.Remark = this.uploadDataList.map(v => v.remark);
                            if (this.form.WaterType === "Sample")
                                infos.FileName = this.uploadDataList.map(v => v.filename);

                            let uploadFormData = new FormData();
                            this.uploadDataList.forEach(item => {
                                if (item.file !== undefined)
                                    uploadFormData.append("", item.file, item.filename);
                            });
                            uploadFormData.append('infos', JSON.stringify(infos));
                            Uploader(uploadFormData).then((_resData) => {
                                this.loading = false;
                                if (_resData.Code === 1) {
                                    that.$message({
                                        message: "上传成功",
                                        type: 'success'
                                    });
                                    //重置上传表单
                                    that.$refs['uploadform'].resetFields();
                                    that.uploadDataList.length = 0;
                                    that.$refs.uploadSelector.clearItems();
                                    that.timer = new Date().getTime();
                                } else {
                                    that.$message.error("上传失败");
                                }
                            });
                        } else {
                            return false;
                        }
                    });
                }
            }
        }
    </script>
    <style scoped>
        .uploadForm{
            margin-top:30px;
            width:50%;
            min-width:600px;
        }
        .line{
            text-align:center;
        }
        .addfilebtn{
            padding:3px 8px;
        }
        .multiFileSelect{
            margin: 0 0 5px 0;
        }
        .multiFileSelect label{
            background: #67C23A;
            border-color: #67C23A;
            color: white;
            border-radius: 4px;
            font-size: small;
            padding-bottom: 4px;
        }
    </style>
